export class VolumeGovernanceResponse {
  public canSchedule: boolean;
  public lastName: string;
  public schedulingWindowUTC: string;
  public schedulingWindowUTCText: string;

  constructor(canSchedule: boolean, lastName: string, schedulingWindowUTC: string, schedulingWindowUTCText: string) {
    this.canSchedule = canSchedule;
    this.lastName = lastName;
    this.schedulingWindowUTC = schedulingWindowUTC;
    this.schedulingWindowUTCText = schedulingWindowUTCText;
  }
}
